import supplierApi from './supplierApi';
import supplierGoodsApi from './supplierGoodsApi';
import stockinApi from './stockinApi';
import stockinResultApi from './stockinResultApi';
import stockoutApi from './stockoutApi';
import stockoutResultsApi from './stockoutResultsApi';
import applysApi from './applysApi';
import purchaseApi from './purchaseApi';

export default {
  ...supplierApi,
  ...supplierGoodsApi,
  ...stockinApi,
  ...stockinResultApi,
  ...stockoutApi,
  ...stockoutResultsApi,
  ...applysApi,
  ...purchaseApi,
};
